var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTv = function SvgTv(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.66663C0 1.6416 1.6416 0 3.66663 0H18.3331C20.3582 0 21.9998 1.6416 21.9998 3.66663V13.7498C21.9998 15.7749 20.3582 17.4165 18.3331 17.4165H3.66663C1.6416 17.4165 0 15.7749 0 13.7498V3.66663ZM3.66663 1.83331C2.65412 1.83331 1.83331 2.65412 1.83331 3.66663V13.7498C1.83331 14.7624 2.65412 15.5832 3.66663 15.5832H18.3331C19.3456 15.5832 20.1664 14.7624 20.1664 13.7498V3.66663C20.1664 2.65412 19.3456 1.83331 18.3331 1.83331H3.66663Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.507 15.6487C9.97705 15.8367 10.2057 16.3702 10.0177 16.8403L8.18435 21.4235C7.99633 21.8936 7.46286 22.1222 6.99281 21.9342C6.52277 21.7462 6.29414 21.2127 6.48216 20.7427L8.31547 16.1594C8.50349 15.6893 9.03696 15.4607 9.507 15.6487Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4928 15.6487C12.0227 15.8367 11.7941 16.3702 11.9821 16.8403L13.8154 21.4235C14.0034 21.8936 14.5369 22.1222 15.0069 21.9342C15.477 21.7462 15.7056 21.2127 15.5176 20.7427L13.6843 16.1594C13.4963 15.6893 12.9628 15.4607 12.4928 15.6487Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTv);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tv.6cac1da1763a6d662325269d58d13935.svg";